import { RadioField } from "@exopengithub/exokit";

interface Language {
	code: string;
	label: string;
}

interface LanguageSelectorProps {
	languages: Language[];
	value: string;
	onChange: (code: string) => void;
}

export const LanguageSelector = ({
	languages,
	value,
	onChange,
}: LanguageSelectorProps) => {
	return (
		<div className="space-y-2">
			{languages.map(({ code, label }) => (
				<div key={code}>
					<RadioField
						label={label}
						name="user_language"
						checked={value === code}
						onChange={(e) => {
							if (e.target.checked) onChange(code);
						}}
					/>
				</div>
			))}
		</div>
	);
};
